import { render, staticRenderFns } from "./SelectProcess.vue?vue&type=template&id=0b261f84&"
import script from "./SelectProcess.vue?vue&type=script&lang=js&"
export * from "./SelectProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports